import joi from 'joi';

import type { GraphPath } from '../GraphPath';
import type { NodeSn } from '../nodes/types';

export const layoutAlgorithms = [
  'universal',
  'circular',
  'hierarchical',
  'upwardTree',
  'downwardTree',
  'radial',
] as const;
export type LayoutAlgorithm = (typeof layoutAlgorithms)[number];
export const DEFAULT_GRAPH_LAYOUT: Layout = 'universal';

export const layouts = [...layoutAlgorithms, 'userDefined'] as const;
export type Layout = (typeof layouts)[number];
/**
 * Pinned = preserve pinned positions even in case new nodes appeared
 */
export const layoutRequests = [...layouts, 'pinned'] as const;
export type LayoutRequest = (typeof layoutRequests)[number];
export interface GraphLayoutRequest {
  path: GraphPath;
  layout: LayoutRequest;
  /**
   * If present, update the layout only for given nodes in the path.
   * We still must provide `path` and all nodes listed here should belong to that path
   * since we currently always handle layouting in context of a path.
   */
  nodeSns?: NodeSn[];
}

export const graphLayoutRequestSchema = joi.object().keys({
  path: joi.string().required(),
  layout: joi
    .string()
    .valid(...layoutRequests)
    .required(),
  nodeSns: joi
    .array()
    .items(joi.string())
    .min(1)
    .when('layout', { is: 'userDefined', then: joi.forbidden() })
    .when('layout', { is: 'pinned', then: joi.forbidden() }),
});

export const graphLayoutRequestForbidRecalculateSchema = joi
  .object()
  .keys({
    path: joi.any(),
    layout: joi.string().valid('pinned'),
    nodeSns: joi.any(),
  })
  .required();
